import { InputNumber } from 'antd';

import {
    getKpiRangeSpan,
    getUniformBinCountFromSize,
} from 'components/molecules/PackArchitecture/kpiAxisConfiguration.utils';
import {
    handleKpiIntegerInputKeyDown,
    KPI_INTEGER_INPUT_PROPS,
    KPI_RANGE_INPUT_CLASS,
    parseKpiIntegerInput,
} from 'components/molecules/PackArchitecture/kpiRangeSlider.utils';
import { MIN_KPI_BIN_COUNT } from 'constants/ppa';

type KpiAxisConfigurationBinCountFieldProps = {
    min: number;
    max: number;
    binCount: number;
    binSize: number;
    countLabel: string;
    sizeLabel: string;
    onBinCountChange: (binCount: number) => void;
};

const KpiAxisConfigurationBinCountField = ({
    min,
    max,
    binCount,
    binSize,
    countLabel,
    sizeLabel,
    onBinCountChange,
}: KpiAxisConfigurationBinCountFieldProps) => {
    const rangeSpan = getKpiRangeSpan(min, max);
    const maxBinCount = Math.max(MIN_KPI_BIN_COUNT, rangeSpan);
    const maxBinSize = Math.max(MIN_KPI_BIN_COUNT, rangeSpan);

    return (
        <div className="flex gap-3">
            <div className="flex min-w-0 flex-1 items-center gap-4">
                <div className="flex items-center gap-2">
                    <span className="text-sm text-blackTransparent88">{countLabel}</span>
                    <InputNumber
                        size="small"
                        controls={false}
                        className={KPI_RANGE_INPUT_CLASS}
                        min={MIN_KPI_BIN_COUNT}
                        max={maxBinCount}
                        value={binCount}
                        {...KPI_INTEGER_INPUT_PROPS}
                        onKeyDown={handleKpiIntegerInputKeyDown}
                        onChange={(value) => {
                            const parsed = parseKpiIntegerInput(value);
                            if (parsed == null) return;
                            onBinCountChange(Math.max(MIN_KPI_BIN_COUNT, Math.min(maxBinCount, parsed)));
                        }}
                    />
                </div>
                <div className="flex items-center gap-2">
                    <span className="text-sm text-blackTransparent88">{sizeLabel}</span>
                    <InputNumber
                        size="small"
                        controls={false}
                        className={KPI_RANGE_INPUT_CLASS}
                        min={MIN_KPI_BIN_COUNT}
                        max={maxBinSize}
                        value={binSize}
                        {...KPI_INTEGER_INPUT_PROPS}
                        onKeyDown={handleKpiIntegerInputKeyDown}
                        onChange={(value) => {
                            const parsed = parseKpiIntegerInput(value);
                            if (parsed == null) return;
                            const nextSize = Math.max(MIN_KPI_BIN_COUNT, Math.min(maxBinSize, parsed));
                            onBinCountChange(getUniformBinCountFromSize(min, max, nextSize));
                        }}
                    />
                </div>
            </div>
        </div>
    );
};

export default KpiAxisConfigurationBinCountField;
